import React from "react";
import FrmDevProjectEditor from "./pages/dev/FrmDevProjectEditor";
import FrmDevProjectList from "./pages/dev/FrmDevProjectList";
import FrmAdminLogin from "./pages/FrmAdminLogin";
import FrmBlank from "./pages/FrmBlank";
import FrmCommonQuest from "./pages/FrmCommonQuest";
import FrmError from "./pages/FrmError";
import FrmMemberLogin from "./pages/FrmMemberLogin";
import FrmMemberTodo from "./pages/FrmMemberTodo";
import FrmProjectEditor from "./pages/FrmProjectEditor";
import FrmProjectList from "./pages/FrmProjectList";
import FrmSpwkExportTest from "./pages/FrmSpwkExportTest";
import FrmSpwkQuestionnaire from "./pages/FrmSpwkQuestionnaire";
import Blank from "./pages/FrmSpwkQuestionnaire/components/Blank";
import FrmSpwkQuestV3 from "./pages/FrmSpwkQuestV3";
import FrmSpwkToHis from "./pages/FrmSpwkToHis";
import FrmSpwkToHisRule from "./pages/FrmSpwkToHis/FrmSpwkToHisRule";
import FrmUniFormDefinition from "./pages/FrmUniFormDefinition";
import FrmUniFuncDefinition from "./pages/FrmUniFuncDefinition";
import FrmUniInputDefinition from "./pages/FrmUniInputDefinition";
import FrmHisManager from "./pages/FrmHisManager";
import FrmCommonExport from "./pages/FrmCommonExport";
import FrmDialogTest from "./pages/FrmDialogTest/FrmDialogTest";
import FrmDialogTest1 from "./pages/FrmDialogTest/FrmDialogTest1";
import FrmCareerSelector from "./pages/FrmDialogTest/FrmCareerSelector";
import FrmProjectMerge from "./pages/FrmProjectMerge";
/*
 * RouteDefine - 是路由定義檔，目前主要包含 url 與 text(是否顯示在左側選單，未來將調整)
 * ROUTE_xxxx - (不含權限) 命名的是導向指定頁面的 route，跳轉往頁時永遠不使用字串，使用此 route (修改統一在此修改)
 * 
 * 接下來分為3個部分
 * 後台頁面: 只能由後台使用者操作，且基本上只能院內使用
 * 受檢者頁面: 前台可用但是必須登入才能用
 * 公開: 主要只有 錯誤頁面 與 受檢者登入畫面
 *
 */


/** 受檢者 - 登入驗證用 */
export const API_ROUTE_auth_info = "/api/auth/info";

/** 受檢者 - 登入驗證用 */
export const API_ROUTE_auth_member_login = "/api/auth/login";

/** 後臺使用者 - 登入驗證用 */
export const API_ROUTE_auth_admin_login = "/api/auth/admin-login";

export type RouteDefine = {
  url: string;
  icon?: React.ReactNode;
  text: string;
  message?: string;
  page?: React.ReactNode;
  data?: any;
};


/** 空白框架 */
export const ROUTE_blank_sample: RouteDefine = { url: "/blank-sample", text: "", page: <FrmBlank /> };

/** 空白頁 */
export const ROUTE_blank: RouteDefine = { url: "", text: "", page: <Blank /> };

/** 錯誤頁 */
export const ROUTE_error: RouteDefine = { url: "/error", text: "", page: <FrmError />, };

/** 後台登入 */
export const ROUTE_admin_login: RouteDefine = { url: "/admin-login", text: "", page: <FrmAdminLogin />, };

/** 受檢者登入 */
export const ROUTE_member_login: RouteDefine = { url: "/login", text: "", page: <FrmMemberLogin />, };

/** 受檢者登入 */
export const ROUTE_member_todo: RouteDefine = { url: "/todo", text: "", page: <FrmMemberTodo />, };

/** 問卷題寫 ★ */
export const ROUTE_spwk_quest: RouteDefine = { url: "/spwk-quest", text: "", page: <FrmSpwkQuestionnaire />, };

/** 一般問卷 ★ */
export const ROUTE_common_quest: RouteDefine = { url: "/common-quest", text: "", page: <FrmCommonQuest />, };


/** 場次列表 */
export const ROUTE_project_list: RouteDefine = { url: "/project-list", text: "", page: <FrmProjectList />, };

/** 場次編輯器 */
export const ROUTE_project_editor: RouteDefine = { url: "/project-editor", text: "", page: <FrmProjectEditor />, };
/** 場次合併 */
export const ROUTE_project_merge: RouteDefine = { url: "/project-merge", text: "", page: <FrmProjectMerge />, };

/** 特作與版本定義 */
export const ROUTE_func_def: RouteDefine = { url: "/func-def", text: "", page: <FrmUniFuncDefinition />, };

/** 問卷內容定義 */
export const ROUTE_form_def: RouteDefine = { url: "/form-def", text: "", page: <FrmUniFormDefinition />, };

/** 問卷Input元件定義 */
export const ROUTE_input_def: RouteDefine = { url: "/input-def", text: "", page: <FrmUniInputDefinition />, };

/** 匯出測試 */
export const ROUTE_export_test: RouteDefine = { url: "/export-test", text: "", page: <FrmSpwkExportTest />, };

/** 一般問卷匯出 */
export const ROUTE_common_export: RouteDefine = { url: "/common-export", text: "", page: <FrmCommonExport />, };

/** 特作匯入院內(與規則說明) */
export const ROUTE_spwk_to_his: RouteDefine = { url: "/spwk-to-his", text: "", page: <FrmSpwkToHis />, };
export const ROUTE_spwk_to_his_rule: RouteDefine = { url: "/spwk-to-his-rule", text: "", page: <FrmSpwkToHisRule />, };


export const ROUTE_dev_project_list: RouteDefine = { url: "/dev-project-list", text: "", page: <FrmDevProjectList />, };
export const ROUTE_dev_project_editor: RouteDefine = { url: "/dev-project-editor", text: "", page: <FrmDevProjectEditor />, };
export const ROUTE_dev_quest_v3: RouteDefine = { url: "/dev-quest-v3", text: "", page: <FrmSpwkQuestV3 />, };

export const ROUTE_member_test: RouteDefine = { url: "/member-test", text: "", page: <FrmMemberTodo />, };

export const ROUTE_his_manager: RouteDefine = { url: "/his_Manager", text: "", page: <FrmHisManager infoList={[]} />, };
export const ROUTE_dialog_test: RouteDefine = { url: "/dialog_test", text: "", page: <FrmDialogTest />, };
export const ROUTE_dialog_test1: RouteDefine = { url: "/dialog_test1", text: "", page: <FrmDialogTest1 />, };
export const ROUTE_career_selector: RouteDefine = { url: "/career_selector", text: "", page: <FrmCareerSelector />, };

export const ADMIN_ROUTES: RouteDefine[] = [
  ROUTE_blank_sample,

  ROUTE_project_list,
  ROUTE_project_editor,
  ROUTE_project_merge,
  
  ROUTE_func_def,
  ROUTE_form_def,
  ROUTE_input_def,

  ROUTE_spwk_to_his,
  ROUTE_spwk_to_his_rule,
  ROUTE_export_test,
  ROUTE_common_export,

  ROUTE_dev_project_list,
  ROUTE_dev_project_editor,
  ROUTE_dev_quest_v3,
  ROUTE_his_manager
];

export const MEMBER_ROUTES: RouteDefine[] = [
  ROUTE_member_todo,// 待辦問卷
  ROUTE_spwk_quest,// 特作問卷
  ROUTE_common_quest// 一般問卷

];

export const PUBLIC_ROUTES: RouteDefine[] = [
  ROUTE_admin_login,
  ROUTE_member_login,
  ROUTE_dialog_test,
  ROUTE_dialog_test1,
  ROUTE_blank,
  ROUTE_error,
  ROUTE_career_selector
];